<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>Client Pricing</h2>
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-btn icon color="orange" dark @click="getPDF" v-on="on" :loading="loadingDownload">
              <v-icon>picture_as_pdf</v-icon>
            </v-btn>
          </template>
          <span>Export a PDF rate sheet</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container container--fluid grid-list-md>
          <v-row justify="center">
            <!--<v-col cols="8">-->
            <v-select label="Select a region..."
                      :items="regions"
                      return-object
                      item-text="name"
                      v-model="region"
            ></v-select>
            <v-dialog width="600px" v-model="newPriceDialog">
              <template v-slot:activator="{ on }">
                <v-btn color="blue darken-1" v-on="on" icon fab v-if="editPricingPermission">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <h2>New line</h2>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-container container--fluid grid-list-lg>
                    <v-row justify="space-around" align="center">
                      <v-col cols="12" md="3">
                        <v-text-field prefix="$" v-model="newPrice.base_rate" label="Base Rate..."
                                      type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field prefix="$" v-model="newPrice.unit_rate" label="Unit Rate..."
                                      type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field prefix="$" v-model="newPrice.unit_rate_after" label="Unit Rate After..."
                                      mask="####"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select :items="categories" v-model="newPrice.category" label="Category"></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions class="justify-center">
                  <v-btn text color="blue-grey lighten-2"
                         @click="newPriceDialog=false; newPrice=Object.assign({}, defaultPrice)">
                    Cancel
                  </v-btn>
                  <v-btn text color="blue darken-1" @click="createNewPrice">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-col cols="12">
              <v-data-table :headers="headers" :items="renderedPricing" v-if="clientPricing">
                <template v-slot:item="props">
                  <tr>
                    <td v-for="(header, index) in headers" :key="index" class="text-center"
                        v-if="header.text!=='Actions'">
                      <v-edit-dialog
                        v-if="editPricingPermission"
                        :return-value.sync="props.item[header.value]"
                        lazy
                        large
                        @save="saveEdit(props.item)"
                        @open="this.$store.commit('displaySnackbar', 'Editing');">
                        {{props.item[header.value]}}
                        <template v-slot:input>
                          <div v-if="header.value !== 'category'">
                            <v-text-field type="number" v-if="header.value !== 'unit_rate_after'"
                                          v-model="props.item[header.value]"
                                          label="Edit"
                                          prefix="$"
                                          single-line>
                            </v-text-field>
                            <v-text-field v-else
                                          type="number"
                                          label="Edit"
                                          mask="####"
                                          prefix="$"
                                          single-line
                                          v-model="props.item[header.value]"
                            >
                            </v-text-field>
                          </div>
                          <v-select v-else
                                    v-model="props.item[header.value]"
                                    :items="categories"></v-select>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td class="text-center" v-if="editPricingPermission">
                      <v-icon color="red" @click="toggleDelete(props.item)">delete</v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      v-if="toBeDeleted"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete the pricing {{toBeDeleted.id}}.<br>
          This action cannot be undone.<br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="deleteDialog = false; toBeDeleted=null">No</v-btn>
          <v-btn text color="red" @click="deletePricing">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios'

    // @group EditClient
    // Table to edit client pricings on EditClientPage
    export default {
        name: "ClientPricing",
        props: {
            // Array of pricings of the client
            clientPricing: Array,
            // Function that toggles dialog in which are the pricing
            toggleDialog: Function,
            // Client_id (number)
            id: Number,
        },
        data() {
            return {
                deleteDialog: false,
                loadingDownload: false,
                newPriceDialog: false,
                toBeDeleted: null,
                region: null,
                newPrice: {
                    base_rate: null,
                    unit_rate: null,
                    unit_rate_after: null,
                    category: null
                },
                defaultPrice: {
                    base_rate: null,
                    unit_rate: null,
                    unit_rate_after: null,
                    category: null
                },
                categories: [
                    'Deliveries - Metro', 'Deliveries - Regional', 'SMS'
                ]
            }
        },
        methods: {
            // @vuese
            // Saves changes made on pricings of a certain client
            // @arg takes the pricing Object (row in pricings table) as an argument
            saveEdit(item) {
                axios.put(process.env.API_URL + '/clients/' + this.id + '/pricing/' + item.id, item)
                    .then((response) => {

                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Creates a new pricing for this client + calls POST endpoint
            createNewPrice() {
                if (this.region === null) {
                    this.$store.commit('displaySnackbar', 'Make sure you chose a region before trying to create a new pricing.');
                } else if (this.newPrice.base_rate < 0 || this.newPrice.unit_rate < 0 || this.newPrice.unit_rate_after < 0) {
                    this.$store.commit('displaySnackbar', 'Make sure you filled the rates with positive values.');
                } else {
                    let body = Object.assign({}, this.newPrice);
                    body.region_id = this.region.id;
                    body.region_name = this.region.name;
                    body.unit_rate_after = parseInt(body.unit_rate_after);
                    axios.post(process.env.API_URL + '/clients/' + this.id + '/pricing', body)
                        .then((response) => {
                            this.clientPricing.unshift(response.data);
                            this.newPrice = Object.assign({}, this.defaultPrice);
                            this.newPriceDialog = false
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                            this.newPriceDialog = false;
                            this.newPrice = Object.assign({}, this.defaultPrice);
                        })
                }
            },
            // @vuese
            // Toggles delete dialog for a certain pricing
            // @arg Takes the pricing Object as an argument --> toBeDeleted
            toggleDelete(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            // @vuese
            // Deletes toBeDeleted pricing and calls the API
            deletePricing() {
                let index = this.clientPricing.indexOf(this.toBeDeleted);
                axios.delete(process.env.API_URL + '/clients/' + this.id + '/pricing/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.clientPricing.splice(index, 1);
                        this.deleteDialog = false;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        this.deleteDialog = false;
                    })
            },
            // @vuese
            // Gets Pricing PDF Ratesheet from API
            getPDF() {
                this.loadingDownload = true;
                axios({
                    url: process.env.API_URL + '/clients/' + this.id + '/pricing/ratesheet',
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        var url = URL.createObjectURL(response.data);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Pricing_ratesheet ' + this.id + '.pdf');
                        document.body.appendChild(link);
                        link.click();
                        this.loadingDownload = false;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        this.loadingDownload = false;
                    })
            }
        },
        computed: {
            // @vuese
            // Rendered Pricing array that will be displayed in the data-table (filtered by chosen region)
            // @type Array
            renderedPricing() {
                let output = [];
                if (this.region !== null) {
                    output = this.clientPricing.filter((pricing) => {
                        return pricing.region_id === this.region.id;
                    });
                }
                return output

            },
            editPricingPermission() {
                return this.$store.getters['auth/hasPermission']('client_pricing_edit');
            },
            regions() {
                return this.$store.getters['auth/permissionRegions']('client_pricing_edit');
            },
            headers() {
                let headers = [
                    {text: 'Base rate', value: 'base_rate', align: 'center', sortable: false},
                    {text: 'Unit rate', value: 'unit_rate', align: 'center', sortable: false},
                    {text: 'Unit rate after', value: 'unit_rate_after', align: 'center', sortable: false},
                    {text: 'Category', value: 'category', align: 'center', sortable: false},
                ];

                if (this.editPricingPermission) {
                    headers.push({text: 'Actions', value: 'actions', align: 'center', sortable: false})
                }

                return headers;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientPricing.vue